'use strict';

module.exports = ['$scope', '$rootScope', '$controller', 'ModalSvc', function ($scope, $rootScope, $controller, ModalSvc) {

    $controller('OrdersBaseCalendarCtrl', {$scope: $scope});

    //$scope.getDateForNewEntry = function (day) {
    //
    //    if (day) {
    //        var selectedDay = day;
    //        var year = day.year;
    //        var month = day.month;
    //    }
    //    var date = selectedDay ? moment(year + '-' + month + '-' + selectedDay.day, "YYYY-MM-DD") : moment();
    //    return date.format($rootScope.dateFormat.moment);
    //};

    $scope.openOrderRequestModal = function ($event, config) {
        $event.stopPropagation();
        ModalSvc.viewOrderRequestModal.open(config);
    };

    $scope.hasOrderRequests = function (item) {
        return item.order_request_dates.length > 0;
    };

    // ------------------
    // Initialization
    // ------------------

    $scope.dataServiceMethod = "getCustomerCalendarData";

    $scope.currentMonthClick();
}];
